export default __webpack_public_path__ + "static/default-b3c5970b54032b84ca601ee544996902.svg";